import comp from "./CategoryGradeBoundary";
export default comp;
